import { Button, Heading, Modal, ModalProps } from '@boltenergy-be/design-system'
import { useStoreSelector } from 'hooks/store.ts'
import { useTranslation } from 'react-i18next'
import { UserTypes } from 'store/auth/types.ts'
import Link from 'components/link/Link.tsx'
import { routes } from 'types/routes.ts'

const BlockResubscriptionModal = ({
  isOpen,
  onRequestClose,
  onContinue
}: Pick<ModalProps, 'isOpen' | 'onRequestClose'> & { onContinue: () => void }) => {
  // Redux
  const { userType } = useStoreSelector((store) => store.auth)

  // i18n
  const { t } = useTranslation('contracts', { keyPrefix: 'blockResubscription' })
  const { t: tX } = useTranslation()

  // Constants
  const context = userType === UserTypes.SUPER_USER ? 'superuser' : 'customer'

  return (
    <Modal
      {...{ isOpen, onRequestClose }}
      title={t(($) => $.title, {
        context: context
      })}
      titleVariant="h4"
    >
      <p>
        {t(($) => $.description, {
          context: context
        })}
      </p>

      {userType !== UserTypes.SUPER_USER && (
        <div>
          <Heading as="h2" variant="h6" weight="semi-bold">
            {t(($) => $.subtitle)}
          </Heading>
          <p>{t(($) => $.extraContext)}</p>
        </div>
      )}

      {userType === UserTypes.SUPER_USER ? (
        <div className="flex-row gap-300">
          <Button type="button" variant="secondary" isFullwidthMobile onClick={onContinue}>
            {t(($) => $.addAnyway)}
          </Button>
          <Button type="button" isFullwidthMobile onClick={onRequestClose}>
            {tX(($) => $.cancel)}
          </Button>
        </div>
      ) : (
        <Link href={routes.BILLING_INVOICES} representation="button" isFullwidthMobile>
          {t(($) => $.toInvoices)}
        </Link>
      )}
    </Modal>
  )
}

export default BlockResubscriptionModal
